<template>
  <Layout
    :errors="errors"
    :title="trans(`models.${resourceType}.content.index.title`)"
    :toasts="toasts"
    :resource="models"
  >
    <template #top>
      <resource-action-header
        :model="getMetaDummy()"
        :action="'index'"
        :title="trans(`models.${resourceType}.content.index.title`)"
      >
        <div class="col flex-grow-1 align-self-center px-0">
          <slot name="searchInput">
            <search-bar
              :name="'subject'"
              :subject="null"
              :label="trans('components.search.PLACEHOLDER')"
              :resourceType="resourceType"
              :style="'width:100%; height:2.5rem; min-height:2.5rem; padding: 0.5rem;'"
            ></search-bar>
          </slot>
        </div>
        <div class="col flex-grow-0 align-self-center px-0">
          <component
            :is="customActionBox(aspect)"
            :data="customActionData"
            :params="getIndexParams()"
            :resource-type="resourceType"
            :route="route(`${routePrefix}.${resourceType}.adjust`, getIndexParams())"
          ></component>
        </div>
      </resource-action-header>
    </template>
    <div class="card rounded-corner">
      <div class="card-body position-relative">
        <resource-collection
          :collection-type="models.meta.config.component?.type ?? 'list'"
          :mode="'full'"
          :models="models"
          :pagination="false"
          @add-toast="addToast"
        ></resource-collection>
      </div>
    </div>
    <template #footer-main>
      <div v-if="models.page" class="p-3">
        <pagination :name="trans(`models.${resourceType}.name.plural`)" :resource="models"></pagination>
      </div>
    </template>
  </Layout>
</template>

<script>
import Layout from '@kanrisha/Pages/Layout';
import Pagination from '@kanrisha/components/Pagination';
import ResourceActionButtons from '@kanrisha/components/Links/ResourceActionButtons';
import ResourceCollection from '@kanrisha/components/ResourceCollection';
import useCustomActionBox from '@kanrisha/composables/useCustomActionBox';
import useResourceParams from '@kanrisha/composables/useResourceParams';
import useResource from '@kanrisha/composables/useResource';
import useToasts from '@kanrisha/composables/useToasts';
import ResourceActionHeader from '@kanrisha/components/Layout/ResourceActionHeader';
import SearchBar from "@kanrisha/components/SearchBar";

export default {
  components: {
    SearchBar,
    ResourceActionHeader,
    Layout,
    Pagination,
    ResourceActionButtons,
    ResourceCollection,
  },
  props: {
    aspectMenuItems: { type: Object, default: () => {} },
    models: { type: Object, default: () => {} },
    toasts: { type: Object, default: () => {} },
    errors: { type: Object, default: () => {} },
    meta: { type: Object, default: () => {} },
    config: { type: Object, default: () => {} },
    adjustments: { type: Object, default: () => {} },
    sort: { type: String, default: () => 'id' },
    filter: { type: Object, default: () => {} },
    excludeNull: { type: Object, default: () => {} },
    customActionData: { type: Object, default: () => {} },
  },
  setup(props) {
    const { resourceType } = useResource(props, props.models);
    const { customActionBox } = useCustomActionBox(props);
    const { addToast } = useToasts(props);
    const { getIndexParams } = useResourceParams(props);

    const getMetaDummy = () => {
      return {
        data: [],
        meta: props.models.meta,
      };
    };

    return {
      addToast,
      customActionBox,
      getMetaDummy,
      getIndexParams,
      resourceType,
    };
  },
};
</script>
